// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GetCancelOrderApiParameter, cancelOrder } from "@ces/App/Services/OrderService";
import {
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandlerDiscreteParameter<
    GetCancelOrderApiParameter & HasOnSuccess & HasOnError<string>,
    GetCancelOrderApiParameter,
    CancelResult
>;

export interface CancelResult {
    successful?: boolean;
    errorMessage?: string;
}

export const DispatchBeginCancelOrder: HandlerType = props => {
    props.dispatch({
        type: "Pages/OrderDetails/BeginCancelOrder",
    });
};

export const XngPopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        orderNumber: props.parameter.orderNumber,
    };
};

export const XngSendDataToApi: HandlerType = async props => {
    props.apiResult = await cancelOrder(props.apiParameter);
};

export const DispatchCompleteCancelOrder: HandlerType = props => {
    props.dispatch({
        type: "Pages/OrderDetails/CompleteCancelOrder",
    });
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult?.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage as any);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult?.successful) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.();
    }
};

export const chain = [
    DispatchBeginCancelOrder,
    XngPopulateApiParameter,
    XngSendDataToApi,
    DispatchCompleteCancelOrder,
    ExecuteOnErrorCallback,
    ExecuteOnSuccessCallback,
];

const xCancelOrder = createHandlerChainRunner(chain, "xCancelOrder");
export default xCancelOrder;
